export const isHTML = (str?: string) => {
  if (str) {
    const doc = new DOMParser().parseFromString(str, "text/html");

    return Array.from(doc.body.childNodes).some(
      (node) => node.nodeType === Node.ELEMENT_NODE
    );
  }
};
